import { cn } from "@theprelude/core";
import { useId } from "react";

export const IntuneIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => {
  const clipPathId = useId();

  return (
    <svg
      className={cn("size-4 flex-shrink-0", className)}
      {...props}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 13H13.5H18V11L20 13L21 14L18 17V15H10V17H12V19H4V17H8V15H0.9918C0.44405 15 0 14.5511 0 13.9925V1.00748C0 0.45107 0.45531 0 0.9918 0H19.0082C19.556 0 20 0.44892 20 1.00748V6.28674V6.5H23C23.5523 6.5 24 6.94772 24 7.5V23C24 23.5523 23.5523 24 23 24H15C14.4477 24 14 23.5523 14 23V17H16V22H22V8.5H11.792C11.4062 9.38295 10.5252 10 9.5 10C8.11929 10 7 8.88071 7 7.5C7 6.11929 8.11929 5 9.5 5C10.5252 5 11.4062 5.61705 11.792 6.5H18V6.28674V2H2V13ZM19 19C19.5523 19 20 19.4477 20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20C18 19.4477 18.4477 19 19 19Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.213257)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
